import { render, staticRenderFns } from "./allocationHostDetail.vue?vue&type=template&id=0c3c5f3e&scoped=true"
import script from "./allocationHostDetail.vue?vue&type=script&lang=js"
export * from "./allocationHostDetail.vue?vue&type=script&lang=js"
import style0 from "./allocationHostDetail.vue?vue&type=style&index=0&id=0c3c5f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c5f3e",
  null
  
)

export default component.exports